@if(type() === 'html'){
<div #htmlLabel></div>
@if(htmlTooltip()){
<iq-tooltip-tooltip
    [id]="id()"
    [label]="htmlTooltip()"
    [tooltipBody]="tooltipBody()"
    [tooltipHeader]="tooltipHeader()"
    [openOnClick]="openOnClick()"
></iq-tooltip-tooltip>
}} @else if(showTooltip()) {
<iq-tooltip-tooltip
    [id]="id()"
    [label]="pullLabelFromFeatureFlag() ? featureFlagLabel() : label()"
    [tooltipBody]="tooltipBody()"
    [tooltipHeader]="tooltipHeader()"
    [openOnClick]="openOnClick()"
    (clickedTooltip)="handleTooltipClick()"
></iq-tooltip-tooltip>
} @else if(type() === 'md') {
<label
    [id]="id()"
    [attr.data-testid]="id()"
    [attr.data-styleTarget]="id()"
    iqBuilderLabeLTruncate
    (isTruncated)="setTruncated($event)"
    [ngClass]="{
        '[&>*]:truncate': isTruncated(),
        'inline-block': shouldTruncate(),
        '[&>*]:w-full': isTruncated(),
        'w-full': shouldTruncate()
    }"
    [matTooltip]="pullLabelFromFeatureFlag() ? featureFlagLabel() : label()"
    [matTooltipDisabled]="!isTruncated()"
    [truncate]="shouldTruncate()"
    [attr.data-uitype]="'label'"
    [datiqTemplateMd]="
        pullLabelFromFeatureFlag() ? featureFlagLabel() : label()
    "
    class="iq-md"
></label>
}
